import { Box, Typography, Link, Divider } from "@mui/material";

export default function () {
  const date = new Date;
  return (
    <>
    <br />
    <Divider style={{backgroundColor: "rgb(130 133 137)" }} />
    <Box className="footer">
  <Typography variant="body2" style={{ fontSize: '1rem' }}>
    If you are having issues with the website, please contact us:
  </Typography>
  <Link href="mailto:support@firstverify.com" underline="none" style={{ fontSize: '1rem' }}>
    support@firstverify.com
  </Link>
  <Link href="tel:(402) 562-5930" underline="none" style={{ fontSize: '1rem' }}>
    (402) 562-5930
  </Link>
  <Typography variant="body2" className="copyright" style={{ fontSize: '1rem' }}>
    © 2014–{date?.getUTCFullYear()} FIRST, VERIFY. All Rights Reserved.
  </Typography>
</Box>

      
    </>
  );
}
